<!--
   Created by qing on 2020/2/19 12:30 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <div
      v-if="likeAndUnlike"
      class="filter-content">
      <van-field v-model="current[0]" placeholder="请输入筛选值"/>
    </div>

    <SelectValue
      v-else
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="current"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>

  <van-field
    v-else
    :disabled="disabled"
    :style="{backgroundColor: disabled ? '#F5F7FA' : '#fff'}"
    @change="filterChange"
    v-model="current[0]">
  </van-field>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {};
    },
    computed: {
      // 包含 不 包含
      likeAndUnlike() {
        return [
          this.FILTER_METHOD_TYPE__LIKE,
          this.FILTER_METHOD_TYPE__UNLIKE
        ].includes(this.method)
      },
    }
  };
</script>

<style lang="less">

</style>
